import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Theme } from '@desygner/ui-common-components';

const Line = styled.div`
  border-top: ${({ thickness, lineStyle, color }) => `${thickness}px ${lineStyle} ${color}`};
  height: ${({ thickness }) => thickness}px;
  line-height: 1px;
  position: absolute;
  left: ${({ centerX }) => centerX}px;
  top: ${({ centerY }) => centerY}px;
  width: ${({ length }) => length}px;
  transform: rotate(${({ angle }) => angle}deg);
`;

export default function LineAtCoordinates ({
  x1, y1,
  x2, y2,
  thickness = 2,
  color = Theme.Color.System.Primary,
  lineStyle = 'dashed',
  children
}) {
  const length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
  const centerX = ((x1 + x2) / 2) - (length / 2);
  const centerY = ((y1 + y2) / 2) - (thickness / 2);
  const angle = Math.abs(y1 - y2) === 0
    ? 0
    : Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);

  return (
    <Line
      thickness={thickness}
      color={color}
      centerX={centerX}
      centerY={centerY}
      length={length}
      angle={angle}
      lineStyle={lineStyle}
    >{children}</Line>
  );
}

LineAtCoordinates.propTypes = {
  x1: PropTypes.number.isRequired,
  y1: PropTypes.number.isRequired,
  x2: PropTypes.number.isRequired,
  y2: PropTypes.number.isRequired,
  thickness: PropTypes.number,
  color: PropTypes.string,
  children: PropTypes.any,
  lineStyle: PropTypes.oneOf([
    'dashed',
    'dotted',
    'solid'
  ])
};
